import { Component, inject } from '@angular/core';
import { MaterialModule } from '../../../modules/material.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { Attachment } from '../../utils/types';
import { FILE_TYPES } from '../../utils/constant';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-file-viewer',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  templateUrl: './file-viewer.component.html',
  styleUrl: './file-viewer.component.scss'
})
export class FileViewerComponent {
  readonly dialogRef = inject(MatDialogRef<FileViewerComponent>);
  readonly data = inject(MAT_DIALOG_DATA);
  
  files: Attachment[] = [];
  currentIndex = 0;
  
  ngOnInit(): void {
    this.files = this.data.files || [];
    this.currentIndex = this.data.startIndex || 0;
  }
  
  closeViewer(): void {
    this.dialogRef.close();
  }
  
  nextFile(): void {
    if (this.currentIndex < this.files.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0; // Loop back to the first file
    }
  }
  
  previousFile(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.files.length - 1; // Loop to the last file
    }
  }
  
  downloadFile(): void {
    const file = this.files[this.currentIndex];
    if (!file) return;

    fetch(file.original_url)
      .then(response => response.blob())
      .then(blob => {
        saveAs(blob, file.name);
      })
      .catch(error => {
        console.error('Error downloading image:', error);
      });
  }

  isImage(file: Attachment): boolean {
    return file?.type?.startsWith(FILE_TYPES.Image);
  }

  getSelectedFileIcon(file: Attachment): { icon: string, className: string } {
    if (file?.type === FILE_TYPES.Pdf) {
      return {
        icon: 'picture_as_pdf',
        className: 'pdf-icon'
      };
    } else if (file?.type === FILE_TYPES.Docx) {
      return {
        icon: 'description',
        className: 'docx-icon'
      };
    } else {
      return {
        icon: 'insert_drive_file',
        className: ''
      }
    }
  }
  
  // Handle keyboard events for navigation
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'ArrowRight') {
      this.nextFile();
    } else if (event.key === 'ArrowLeft') {
      this.previousFile();
    } else if (event.key === 'Escape') {
      this.closeViewer();
    }
  }
} 